<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="800px"
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        icon 
        x-small
        v-on="on"
      >
        <v-icon color="primary">
          mdi-pencil
        </v-icon>
      </v-btn>
    </template>
    
    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Branch"
      text="Update Branch"
      class="mb-0"
      :loading="loading"
    >
      <form v-if="dialog && !loading">
        <v-container>
          <v-row>
            <v-col cols="6">
              <v-row no-gutters>
                <v-col cols="12">
                  <v-text-field
                    v-model="localBranch.branch_name"
                    v-validate="'required'"
                    :error-messages="errors.collect('branch_name')"
                    data-vv-name="branch_name"
                    data-vv-as="branch name"
                    label="Branch Name"
                    outlined
                  />
                </v-col>
                
                <v-col cols="12">
                  <v-text-field
                    v-model="localBranch.branch_contact_no"
                    v-validate="'phoneLength'"
                    v-mask="['###-########']"
                    :error-messages="errors.collect('contactNumber')"
                    data-vv-name="contactNumber"
                    label="Contact Number"
                    outlined
                    :disabled="!localBranch.branch_name"
                    :filled="!localBranch.branch_name"
                  />
                </v-col>
              </v-row>
            </v-col>
            
            <v-col cols="6">
              <v-row no-gutters>
                <v-col cols="12">
                  <v-text-field
                    v-model="localBranch.address_line_one"
                    v-validate="localBranch.branch_name?'required':''"
                    :error-messages="errors.collect('address_line_one')"
                    data-vv-name="address_line_one"
                    data-vv-as="address"
                    outlined
                    :disabled="!localBranch.branch_name"
                    :filled="!localBranch.branch_name"
                    label="Address Line 1"
                  />
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    v-model="localBranch.address_line_two"
                    :disabled="!localBranch.address_line_one"
                    outlined
                    :filled="!localBranch.address_line_one"
                    label="Address Line 2"
                  />
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    v-model="localBranch.address_line_three"
                    :disabled="!localBranch.address_line_one"
                    outlined
                    :filled="!localBranch.address_line_one"
                    label="Address Line 3"
                  />
                </v-col>

                <v-col cols="12">
                  <v-autocomplete
                    v-model="localBranch.postcode"
                    v-validate="'required'"
                    :items="postcodes"
                    item-text="postcode"
                    item-value="postcode"
                    value="postcode"
                    :error-messages="errors.collect('postcode')"
                    data-vv-name="postcode"
                    data-vv-as="postcode"
                    outlined
                    label="Postcode"
                    @input="clearData(); postCodeOnChanged(localBranch.postcode)"
                  />
                </v-col>

                <v-col cols="12">
                  <v-autocomplete
                    v-model="localBranch.city_id"
                    v-validate="localBranch.branch_name?'required':''"
                    :disabled="dropdownDisabled"
                    :filled="!localBranch.postcode"
                    :items="filteredCities"
                    :error-messages="errors.collect('city_id')"
                    data-vv-name="city_id"
                    data-vv-as="city"
                    item-text="name"
                    item-value="id"
                    value="id"
                    outlined
                    label="City"
                    hide-selected
                    @input="cityOnChanged(localBranch.city_id)"
                  />
                </v-col>

                <v-col cols="12">
                  <v-autocomplete
                    v-model="localBranch.state_id"
                    v-validate="localBranch.branch_name?'required':''"
                    :error-messages="errors.collect('state_id')"
                    data-vv-name="state_id"
                    data-vv-as="state"
                    disabled
                    :filled="!localBranch.city_id"
                    :items="states"
                    item-text="name"
                    item-value="id"
                    value="id"
                    label="State"
                    outlined
                    hide-selected
                  />
                </v-col>

                <v-col cols="12">
                  <v-autocomplete
                    v-model="localBranch.country_id"
                    v-validate="localBranch.branch_name?'required':''"
                    :error-messages="errors.collect('country_id')"
                    data-vv-name="country_id"
                    data-vv-as="country"
                    :items="countries"
                    disabled
                    :filled="!localBranch.state_id"
                    item-text="name"
                    item-value="id"
                    value="id"
                    outlined
                    label="Country"
                    hide-selected
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </form> 

      <v-card-actions v-if="dialog && !loading">
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10"
          @click="dialog = false"
        >
          Cancel
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"    
          class="white--text px-10"      
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions> 
    </material-card>  
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      branch: {
        type: Object,
        default: null,
      },
    },
    data () {
      return {
        dialog: false,
        progressing: false,
        localBranch: null,
        loading: false,
        countries: [],
        states: [],
        postcodes: [],
        cities: [],
        dropdownDisabled: null,
        cityIds: [],  
      }
    },
    computed: {
      filteredCities () {
        if (this.localBranch.postcode) {
          this.postCodeOnChanged(this.localBranch.postcode)
        }

        if (this.cityIds.length > 0) {
          return this.cities.filter(city => {
            return this.cityIds.includes(city.id)
          })
        }
        return this.cities      
      },          
    },
    watch: {
      dialog: function (value) {
        if (!value) return false

        this.loading = true

        this.localBranch = { ...this.branch }

        this.$validator.extend('phoneLength', {
          getMessage (field, args) {
            return 'Invalid phone number (at least 9 numbers and max 11)'
          },
          validate (value, args) {
            return value.toString().length >= 10 && value.toString().length <= 12
          },
        })

        Promise.all([
          this.$api.countries().list(),
          this.$api.states().list(),
          this.$api.cities().list(),
          this.$api.postcodes().list(),
        ])
          .then(([countries, states, cities, postcodes]) => {
            this.countries = countries.data
            this.states = states.data
            this.cities = cities.data
            this.postcodes = _.orderBy(postcodes.data, ['postcode'], ['asc'])

            this.loading = false
          })
      },
    },
    methods: { 
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.progressing = true

            this.$api.hrisBranches().update(this.branch.branch_uid, this.prepareFormData())
              .then(response => {
                if (response.status === 200) {
                  this.$emit('updated')
                  this.$snack({ message: 'Branch updated' })

                  this.progressing = false
                  this.dialog = false
                }
              })
          })
      },
      
      prepareFormData () {
        return {
          branch_name: this.localBranch.branch_name,
          branch_contact_no: this.localBranch.branch_contact_no,
          address_line_one: this.localBranch.address_line_one,
          address_line_two: this.localBranch.address_line_two,
          address_line_three: this.localBranch.address_line_three,
          postcode: this.localBranch.postcode,
          city_id: this.localBranch.city_id,
          state_id: this.localBranch.state_id,
          country_id: this.localBranch.country_id,
        }
      },
      clearData () {
        this.localBranch.city_id = null
        this.localBranch.state_id = null
        this.localBranch.country_id = null
      },
      postCodeOnChanged (postcodeValue) {
        var cityID = this.postcodes.filter(p => {
          return p.postcode === postcodeValue
        })  

        this.cityIds = this.cities.filter(city => {
          return cityID.some(city2 => {
            return city2.city_id === city.id
          })
        }).map(city3 => {
          return city3.id
        })

        if (this.cityIds.length > 1) {
          this.dropdownDisabled = false
        } else {
          this.dropdownDisabled = true

          let cityId = (this.postcodes.find(postcode => {
            return postcode.postcode === postcodeValue
          }) || {}).city_id

          if (cityId) {
            var cityObject = this.getCity(cityId)
            if (cityObject) {
              this.localBranch.city_id = cityObject.id
              var stateObject = this.getState(cityObject.state_id)
              
              if (stateObject) {
                this.localBranch.state_id = stateObject.id
                var countryObject = this.getCountry(stateObject.country_id)
                this.localBranch.country_id = countryObject.id
              }
            }
          }
        }       
      },
      cityOnChanged (cityId) {
        var cityObject = this.getCity(cityId)
        if (cityObject) {
          var stateObject = this.getState(cityObject.state_id)
          
          if (stateObject) {
            this.localBranch.state_id = stateObject.id
            var countryObject = this.getCountry(stateObject.country_id)
            this.localBranch.country_id = countryObject.id
          }
        }
      },
      getCity (cityId) {
        if (isNaN(parseInt(cityId))) return null
        return this.cities.find(city => {
          return city.id === parseInt(cityId)
        })
      },
      getState (stateId) {
        if (isNaN(parseInt(stateId))) return null
        return this.states.find(state => {
          return state.id === parseInt(stateId)
        })
      },
      getCountry (countryId) {
        if (isNaN(parseInt(countryId))) return null
        return this.countries.find(country => {
          return country.id === parseInt(countryId)
        })
      },
  
    },
  }
</script>
